// NGRX
import {createFeatureSelector} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState, Update} from '@ngrx/entity';
// Actions
// Models
import {QueryParamsModel} from '../../_base/crud';
import {ScopeModel} from '../_models/scope.model';
import {ScopeActions, ScopeActionTypes} from '../_actions/scope.actions';

export interface ScopesState extends EntityState<ScopeModel> {
	listLoading: boolean;
	actionsloading: boolean;
	totalCount: number;
	lastCreatedScopeId: number;
	lastQuery: QueryParamsModel;
	showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<ScopeModel> = createEntityAdapter<ScopeModel>();

export const initialScopesState: ScopesState = adapter.getInitialState({
	scopeForEdit: null,
	listLoading: false,
	actionsloading: false,
	totalCount: 0,
	lastCreatedScopeId: undefined,
	lastQuery: new QueryParamsModel({}),
	showInitWaitingMessage: true
});

export function scopesReducer(state = initialScopesState, action: ScopeActions): ScopesState {
	switch (action.type) {
		case ScopeActionTypes.ScopesPageToggleLoading: {
			return {
				...state, listLoading: action.payload.isLoading, lastCreatedScopeId: undefined
			};
		}
		case ScopeActionTypes.ScopeActionToggleLoading: {
			return {
				...state, actionsloading: action.payload.isLoading
			};
		}
		case ScopeActionTypes.ScopeOnServerCreated:
			return {
				...state
			};
		case ScopeActionTypes.ScopeCreated:
			return adapter.addOne(action.payload.scope, {
				...state, lastCreatedScopeId: action.payload.scope.id
			});
		case ScopeActionTypes.ScopeUpdated:
			return adapter.updateOne(action.payload.partialScope, state);
		case ScopeActionTypes.ScopesStatusUpdated: {
			const _partialScopes: Update<ScopeModel>[] = [];
			// tslint:disable-next-line:prefer-const
			for (let i = 0; i < action.payload.scopes.length; i++) {
				_partialScopes.push({
					id: action.payload.scopes[i].id,
					changes: {
						status: action.payload.status
					}
				});
			}
			return adapter.updateMany(_partialScopes, state);
		}
		case ScopeActionTypes.OneScopeDeleted:
			return adapter.removeOne(action.payload.id, state);
		case ScopeActionTypes.ManyScopesDeleted:
			return adapter.removeMany(action.payload.ids, state);
		case ScopeActionTypes.ScopesPageCancelled: {
			return {
				...state, listLoading: false, lastQuery: new QueryParamsModel({})
			};
		}
		case ScopeActionTypes.ScopesPageLoaded: {
			return adapter.addMany(action.payload.scopes, {
				...initialScopesState,
				totalCount: action.payload.totalCount,
				listLoading: false,
				lastQuery: action.payload.page,
				showInitWaitingMessage: false
			});
		}
		default:
			return state;
	}
}

export const getScopeState = createFeatureSelector<ScopeModel>('scopes');

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = adapter.getSelectors();
